import { render, staticRenderFns } from "./betReward.vue?vue&type=template&id=2e18fdc3&scoped=true"
import script from "./betReward.vue?vue&type=script&lang=js"
export * from "./betReward.vue?vue&type=script&lang=js"
import style0 from "./betReward.vue?vue&type=style&index=0&id=2e18fdc3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e18fdc3",
  null
  
)

export default component.exports